import React from 'react';
import GenericSvgIcon from "@Icons/GenericSvgIcon";
import IconType from "@/types/Icon.type";

function IconSwitch(props: IconType) {
    const {
        width = '16',
        height = '16',
        fill = '#4a4a4a',
        viewBox = '0 0 16 16',
        title = 'IconSwitch',
        ...rest
    } = props

    return (
        <GenericSvgIcon
            {...{width, height, fill, viewBox, title, ...rest}}
            svgIconPath={(
                <g fill="none">
                    <path
                        d="m2.75 1h10.5c.9665 0 1.75.7835 1.75 1.75v10.5c0 .9665-.7835 1.75-1.75 1.75h-10.5c-.9665 0-1.75-.7835-1.75-1.75v-10.5c0-.9665.7835-1.75 1.75-1.75z"
                        stroke={fill}
                    />
                    <g fill={fill}>
                        <path
                            d="m10.5005 3.11308.0181.01871 1.3889 1.61015c.0621.06511.0925.16116.0925.26733 0 .08847-.0211.16992-.0683.23695l-1.413 1.64043c-.0768.08133-.168.11335-.2687.11335s-.1919-.03202-.2613-.10519c-.13563-.14295-.15858-.33644-.04343-.49825l.03332-.04115.82941-.96579-4.44689.00023c-.21532 0-.36111-.15365-.36111-.38058 0-.19272.10666-.3426.28773-.37441l.05634-.00548 4.46393-.00093-.8269-.96236c-.14863-.15623-.14863-.37771.0076-.54236.1356-.14295.3192-.16713.4728-.04577z"
                        />
                        <path
                            d="m7.4995 9.11308-.0181.01871-1.38889 1.61011c-.06213.0652-.09251.1612-.09251.2674 0 .0884.0211.1699.06831.2369l1.41301 1.6404c.07681.0814.16795.1134.26868.1134s.19187-.032.2613-.1052c.13563-.1429.15858-.3364.04343-.4982l-.03332-.0412-.82941-.9658 4.4469.0002c.2153 0 .3611-.1536.3611-.3805 0-.1928-.1067-.3426-.2877-.3744l-.0564-.0055-4.4639-.0009.8269-.96241c.14863-.15623.14863-.37771-.0076-.54236-.13563-.14295-.31922-.16713-.47276-.04577z"
                        />
                    </g>
                </g>
            )}
        />
    );
}

export default IconSwitch;
